import axios from "axios";
import { getApiHeaders } from "../../api/apiHeaders";
//import { I18n } from "react-redux-i18n";
import {
    CALENDAR_LIST_ATTEMPT,
    CALENDAR_LIST_SUCCESS,
    CALENDAR_LIST_FAILED,
    ////////////////////
} from "../types/calendarTypes";
import { config } from "../../config";

const url_api = config.api.web;

export function loading() {
    return {
        type: CALENDAR_LIST_ATTEMPT
    };
}

export function success(data) {
    return {
        type: CALENDAR_LIST_SUCCESS,
        data: data
    };
}

export function failed(error) {
    return {
        type: CALENDAR_LIST_FAILED,
        error: error
    };
}

export const loadList = (data: Object) => async dispatch => {
    dispatch(loading());
    await axios
        .get(url_api + "calendar/", {
            params: data.params,//{
            // id: data.user_id,
            //token: data.token,
            //lang: I18n.t("locale")
            // },
            headers: getApiHeaders(),
        })
        .then(function (response) {
            //console.log(response);
            if (response.status < 300) {
                if (response.data.status === 'Success')
                    dispatch(success(response.data.body));
                else dispatch(failed(response.data.body));
            } else {
                dispatch(failed("try_later"));
            }
        })
        .catch(function (error) {
            console.log(error);
            if (error.Error) {
                dispatch(failed("try_later"));
            } else {
                dispatch(failed("try_later"));
            }
            return;
        });
};
